import React from 'react';


/*
 * Clone the whole React elements tree recusively down with new props.
 *
 * Reference:
 * https://gist.github.com/dandelany/1ff06f4fa1f8d6f89c5e
 */
export function cloneChildrenRecursively(children, props = {},
                                         filterChild = () => true,
                                         getMoreProps = () => {}) {
  return React.Children.map(children, child => {
    let _props = Object.assign({}, props);

    if (React.isValidElement(child) === false) {
      _props = {};
    }

    if (filterChild(child)) {
      const moreProps = getMoreProps(child);
      _props = Object.assign({}, props, moreProps);
    } else {
      _props = {};
    }

    // String doesn't have props..
    if (child.props) {
      _props.children = cloneChildrenRecursively(
        child.props.children, props, filterChild, getMoreProps
      );
      return React.cloneElement(child, _props);
    }

    return child;
  });
}



// WEBPACK FOOTER //
// ./src/shared/helpers/reactHelper.js